"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.groups.selectNumber': 'Numero di telefono',
    'whatsapp.groups.selectNumberPlaceholder': 'Seleziona un numero di telefono...',
    'whatsapp.groups.loadFailed': 'Impossibile caricare i gruppi WhatsApp.',
    'whatsapp.groups.noGroups': 'Nessun gruppo trovato.',
    'whatsapp.groups.trackingOn': 'Monitoraggio attivo',
    'whatsapp.groups.trackingOff': 'Monitoraggio inattivo',
    'whatsapp.groups.loading': 'Caricamento...',
    'whatsapp.groups.notFound': 'Gruppo non trovato.',
    'whatsapp.groups.info': 'Informazioni gruppo',
    'whatsapp.groups.name': 'Nome',
    'whatsapp.groups.waId': 'ID WhatsApp',
    'whatsapp.groups.phone': 'Numero di telefono',
    'whatsapp.groups.tracking': 'Abilita monitoraggio messaggi',
    'whatsapp.groups.pinMessage.label': 'Messaggio fissato',
    'whatsapp.groups.pinMessage.placeholder': 'Contenuto del messaggio da fissare nel gruppo...',
    'whatsapp.groups.pinMessage.hint': 'Se il monitoraggio è attivo e il bot è amministratore, questo messaggio verrà fissato.',
    'whatsapp.groups.pinReminder.label': 'Reinvia messaggio fissato',
    'whatsapp.groups.pinReminder.intervalLabel': 'Intervallo (ore)',
    'whatsapp.groups.pinReminder.hint': 'Reinvia il messaggio fissato quando sono arrivati almeno 10 nuovi messaggi dall\'ultimo promemoria.',
    'whatsapp.groups.tracking.badge': 'Monitorato',
    'whatsapp.groups.communicationType.wa': 'WA',
    'whatsapp.groups.communicationType.tele': 'TELE',
    'whatsapp.groups.trackingEnabled': 'Monitoraggio messaggi abilitato.',
    'whatsapp.groups.trackingDisabled': 'Monitoraggio messaggi disabilitato.',
    'whatsapp.groups.trackingFailed': 'Impossibile aggiornare le impostazioni di monitoraggio.',
    'whatsapp.groups.messages': 'Messaggi monitorati',
    'whatsapp.groups.noMessages': 'Nessun messaggio monitorato ancora.',
    'whatsapp.groups.openGroup': 'Apri gruppo',
    'whatsapp.groups.back': 'Indietro',
    'whatsapp.groups.copyUrl.label': 'Copia link pubblico',
    'whatsapp.groups.copyUrl.copied': 'Copiato!',
    'whatsapp.groups.copyUrl.title': 'Copia un link pubblico a questo gruppo (con filtro opzionale del numero di telefono)',
    'whatsapp.groups.copyUrl.success': 'Link pubblico copiato negli appunti.',
    'whatsapp.groups.copyUrl.failed': 'Impossibile copiare il link pubblico.',
    'whatsapp.groups.botSettings': 'Impostazioni bot',
    'whatsapp.groups.avatar': 'Avatar',
    'whatsapp.groups.selectAvatar': '-- Seleziona avatar --',
    'whatsapp.groups.botInstruction': 'Istruzione bot',
    'whatsapp.groups.botInstructionPlaceholder': 'Inserire istruzioni per il bot WhatsApp...',
    'whatsapp.groups.saveSettings': 'Salva impostazioni',
    'whatsapp.groups.settingsSaved': 'Impostazioni salvate con successo.',
    'whatsapp.groups.settingsFailed': 'Impossibile salvare le impostazioni.',
    'whatsapp.groups.listTitle': 'Gruppi WhatsApp',
    'whatsapp.groups.addGroup': 'Aggiungi gruppo',
    'whatsapp.groups.announce.label': 'Tutti gli utenti possono scrivere nel gruppo',
    'whatsapp.groups.announce.hint': 'Quando abilitato, tutti i membri del gruppo possono inviare messaggi (non solo gli admin).',
    'whatsapp.groups.announce.saved': 'Modalità annuncio aggiornata.',
    'whatsapp.groups.announce.failed': 'Impossibile aggiornare la modalità annuncio.',
    'whatsapp.groups.remoteAccess.label': 'Accesso remoto',
    'whatsapp.groups.accessPassword.label': 'Password di accesso',
    'whatsapp.groups.security.save': 'Imposta sicurezza',
    'whatsapp.groups.security.saved': 'Impostazioni di sicurezza salvate.',
    'whatsapp.groups.security.failed': 'Impossibile salvare le impostazioni di sicurezza.',
    'whatsapp.groups.gate.title': 'Accesso al gruppo',
    'whatsapp.groups.gate.password': 'Password',
    'whatsapp.groups.gate.submit': 'Entra',
    'whatsapp.groups.gate.error': 'Password non valida. Riprovare.',
    'whatsapp.groups.dateFrom': 'Da',
    'whatsapp.groups.dateTo': 'A',
    'whatsapp.groups.summarize': 'Riassumi',
    'whatsapp.groups.summary': 'Riepilogo',
    'whatsapp.groups.summaries.title': 'Riepiloghi',
    'whatsapp.groups.summaries.empty': 'Nessun riepilogo ancora.',
    'whatsapp.groups.summaries.date': 'Data',
    'whatsapp.groups.summaries.view': 'Visualizza',
    'whatsapp.groups.summaries.excerpt': 'Sommario',
    'whatsapp.groups.summaries.modalTitle': 'Dettagli riepilogo',
    'whatsapp.groups.summarizeDone': 'Riepilogo generato con successo.',
    'whatsapp.groups.summarizeFailed': 'Impossibile generare il riepilogo.',
    'whatsapp.groups.syncMessages.button': 'Sincronizza messaggi',
    'whatsapp.groups.syncMessages.done': 'Messaggi sincronizzati con successo.',
    'whatsapp.groups.sendMessage.title': 'Invia messaggio',
    'whatsapp.groups.sendMessage.placeholder': 'Scrivi un messaggio da inviare al gruppo...',
    'whatsapp.groups.sendMessage.send': 'Invia',
    'whatsapp.groups.sendMessage.success': 'Messaggio inviato.',
    'whatsapp.groups.sendMessage.failed': 'Impossibile inviare il messaggio.',
    'whatsapp.groups.trackingDisabledHint': 'Il monitoraggio è disabilitato per questo gruppo. Abilita il monitoraggio per visualizzare i messaggi, inviare messaggi e visualizzare i riepiloghi.',
    'whatsapp.groups.syncMessages.failed': 'Impossibile sincronizzare i messaggi.',
    'whatsapp.groups.media.download': 'Scarica',
    'whatsapp.groups.media.downloading': 'Download in corso...',
    'whatsapp.groups.media.downloadFailed': 'Impossibile scaricare il file multimediale.',
    'whatsapp.groups.media.attachment': 'Allegato',
    'whatsapp.groups.loading_groups': 'Caricamento gruppi...',
    'whatsapp.groups.members.title': 'Membri del gruppo',
    'whatsapp.groups.members.sync': 'Sincronizza',
    'whatsapp.groups.members.syncFailed': 'Impossibile sincronizzare i membri.',
    'whatsapp.groups.members.empty': 'Nessun membro. Clicca Sincronizza per caricare da WhatsApp.',
    'whatsapp.groups.members.phone': 'Telefono',
    'whatsapp.groups.members.username': 'Nome utente',
    'whatsapp.groups.members.id': 'WA ID',
    'whatsapp.groups.members.name': 'Nome',
    'whatsapp.groups.members.role': 'Ruolo',
    'whatsapp.groups.members.superAdmin': 'Super Admin',
    'whatsapp.groups.members.admin': 'Admin',
    'whatsapp.groups.members.member': 'Membro',
    'whatsapp.groups.members.promote': 'Promuovi ad admin',
    'whatsapp.groups.members.promoted': 'Membro promosso ad admin.',
    'whatsapp.groups.members.promoteFailed': 'Impossibile promuovere il membro.',
    'whatsapp.groups.addParticipants.title': 'Aggiungi partecipanti',
    'whatsapp.groups.addParticipants.phonePlaceholder': 'Inserisci numero di telefono...',
    'whatsapp.groups.addParticipants.addPhone': 'Aggiungi numero',
    'whatsapp.groups.addParticipants.noPhonesYet': 'Nessun numero di telefono aggiunto.',
    'whatsapp.groups.addParticipants.submit': 'Aggiungi partecipanti',
    'whatsapp.groups.addParticipants.success': 'Partecipanti aggiunti con successo.',
    'whatsapp.groups.addParticipants.failed': 'Impossibile aggiungere i partecipanti.',
    'whatsapp.groups.members.remove': 'Rimuovi',
    'whatsapp.groups.members.removed': 'Membro rimosso dal gruppo.',
    'whatsapp.groups.members.removeFailed': 'Impossibile rimuovere il membro.',
    'whatsapp.groups.members.feedBotData': 'Dati per il bot',
    'whatsapp.groups.members.allowBotUsage': 'Consenti uso del bot',
    'whatsapp.groups.members.updateFailed': 'Impossibile aggiornare le impostazioni del membro.',
    'whatsapp.groups.joinGroup': 'Unisciti al gruppo',
    'whatsapp.groups.joinLink.modalTitle': 'Unisciti al gruppo WhatsApp',
    'whatsapp.groups.joinLink.hint': 'Incolla un link di invito al gruppo WhatsApp (es. https://chat.whatsapp.com/...) e l\'agente si unirà al gruppo.',
    'whatsapp.groups.joinLink.label': 'Link di invito',
    'whatsapp.groups.joinLink.placeholder': 'https://chat.whatsapp.com/...',
    'whatsapp.groups.joinLink.required': 'Inserisci un link di invito.',
    'whatsapp.groups.joinLink.submit': 'Unisciti',
    'whatsapp.groups.joinLink.cancel': 'Annulla',
    'whatsapp.groups.joinLink.success': 'Gruppo raggiunto con successo.',
    'whatsapp.groups.joinLink.failed': 'Impossibile unirsi al gruppo.',
    'whatsapp.groups.gate.notAllowed': 'Questo gruppo non è disponibile per il numero di telefono selezionato.',
    'whatsapp.groups.trackLogs': 'Registro attività',
    'whatsapp.groups.trackLogs.noLogs': 'Nessun registro attività disponibile.',
    'whatsapp.groups.trackLogs.logType.neutral': 'Neutro',
    'whatsapp.groups.trackLogs.logType.good': 'Buono',
    'whatsapp.groups.trackLogs.logType.warning': 'Avvertimento',
    'whatsapp.groups.trackLogs.logType.critical': 'Critico',
};
